import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { rem } from "./auth-service-tools172.js";
import "react";
import { getFontSize } from "./auth-service-tools185.js";
import { createVarsResolver } from "./auth-service-tools191.js";
import { useProps } from "./auth-service-tools225.js";
import { useStyles } from "./auth-service-tools198.js";
import { Box } from "./auth-service-tools244.js";
import { factory } from "./auth-service-tools248.js";
import { useInputWrapperContext } from "./auth-service-tools304.js";
import classes from "./auth-service-tools306.js";
const defaultProps = {};
const varsResolver = createVarsResolver((_, _ref) => {
  let {
    size
  } = _ref;
  return {
    description: {
      "--input-description-size": size === void 0 ? void 0 : `calc(${getFontSize(size)} - ${rem(2)})`
    }
  };
});
const InputDescription = factory((_props, ref) => {
  const props = useProps("InputDescription", defaultProps, _props);
  const {
    classNames,
    className,
    style,
    styles,
    unstyled,
    vars,
    size,
    __staticSelector,
    __inheritStyles = true,
    variant,
    ...others
  } = useProps("InputDescription", defaultProps, props);
  const ctx = useInputWrapperContext();

  const _getStyles = useStyles({
    name: ["InputWrapper", __staticSelector],
    props,
    classes,
    className,
    style,
    classNames,
    styles,
    unstyled,
    rootSelector: "description",
    vars,
    varsResolver
  });

  const getStyles = __inheritStyles && (ctx == null ? void 0 : ctx.getStyles) || _getStyles;
  return /* @__PURE__ */jsxRuntimeExports.jsx(Box, {
    component: "p",
    ref,
    variant,
    size,
    ...getStyles("description", (ctx == null ? void 0 : ctx.getStyles) ? {
      className,
      style
    } : void 0),
    ...others
  });
});
InputDescription.classes = classes;
InputDescription.displayName = "@mantine/core/InputDescription";
export { InputDescription };